import { CircleArrowUp, ShieldAlert } from 'lucide-preact';
import { openExternal, platform, storeName } from '../platform';
import { bannedMessage, bootMessage, logout, updateMessage } from '../state/session';
import { catalog } from '../state/store';
import { AsyncButton } from '../ui/kit';
import { SUPPORT_EMAIL } from './Legal';

export function Logo(props: { size?: 'md' | 'lg' | 'sm' }) {
  return (
    <div class={`brand brand-${props.size ?? 'md'}`}>
      <span class="brand-top">VOXEL</span>
      <span class="brand-bottom">MARINES</span>
    </div>
  );
}

/** Animated stack of voxels used as the loading indicator. */
export function VoxelLoader() {
  return (
    <div class="voxel-loader" aria-hidden="true">
      {Array.from({ length: 9 }, (_, i) => (
        <i key={i} style={{ animationDelay: `${(i % 3) * 0.12 + Math.floor(i / 3) * 0.12}s` }} />
      ))}
    </div>
  );
}

export function BootScreen() {
  return (
    <div class="boot">
      <div class="boot-inner">
        <Logo size="lg" />
        <VoxelLoader />
        <div class="boot-msg">{bootMessage.value}</div>
      </div>
      <div class="boot-version">v{__APP_VERSION__}</div>
    </div>
  );
}

export function BannedScreen() {
  return (
    <div class="boot">
      <div class="boot-inner banned">
        <ShieldAlert size={64} color="#ff5a4a" />
        <h1>Account suspended</h1>
        <p>{bannedMessage.value || 'This account broke the Voxel Marines rules and has been suspended.'}</p>
        <p class="muted">If you think this is a mistake, email {SUPPORT_EMAIL} with your call sign.</p>
        <AsyncButton class="danger" onClick={logout}>
          Log out
        </AsyncButton>
      </div>
    </div>
  );
}

/** This app is older than live-ops allows (`client.versions`). Web reloads; apps open their store page. */
export function UpdateScreen() {
  const url = catalog.value?.clientVersions?.urls[platform];
  const reload = platform === 'web' || (platform === 'desktop' && !url);
  return (
    <div class="boot">
      <div class="boot-inner banned">
        <CircleArrowUp size={64} color="#ffd24a" />
        <h1>Update required</h1>
        <p>{updateMessage.value}</p>
        {reload ? (
          <AsyncButton class="primary" onClick={async () => location.reload()}>
            Reload the game
          </AsyncButton>
        ) : url ? (
          <AsyncButton class="primary" onClick={async () => openExternal(url)}>
            Get the update
          </AsyncButton>
        ) : (
          <p class="muted">Update Voxel Marines from {platform === 'desktop' ? 'our website' : storeName()}.</p>
        )}
        <p class="muted">You have v{__APP_VERSION__}.</p>
      </div>
    </div>
  );
}
